import type { CaixaDoEvento, TerminalCaixa } from './types';

type Bruto = Record<string, unknown>;

function texto(v: unknown): string | null {
  if (v == null) return null;
  const s = String(v).trim();
  return s ? s : null;
}

function numero(v: unknown, padrao = 0): number {
  const n = Number(v);
  return Number.isFinite(n) ? n : padrao;
}

export function normalizarTerminal(bruto: Bruto): TerminalCaixa {
  return {
    terminal: bruto.terminal == null ? null : numero(bruto.terminal),
    terminal_externo: String(bruto.terminal_externo ?? bruto.terminal ?? bruto.id ?? ''),
    apelido: texto(bruto.apelido) ?? texto(bruto.nome) ?? 'Maquininha',
    modelo: texto(bruto.modelo),
    operating_mode: texto(bruto.operating_mode ?? bruto.modo),
    imprime: bruto.imprime === true,
    em_uso_por: texto(bruto.em_uso_por),
    visto_em: texto(bruto.visto_em),
  };
}

export function normalizarCaixa(bruto: Bruto): CaixaDoEvento {
  const ficha = texto(bruto.ficha_por);
  return {
    caixa_id: numero(bruto.caixa_id ?? bruto.id),
    nome: texto(bruto.nome) ?? 'Caixa',
    ativo: bruto.ativo !== false,
    terminal: bruto.terminal == null ? null : numero(bruto.terminal),
    terminal_externo: texto(bruto.terminal_externo ?? bruto.terminal),
    imprime_fichas: bruto.imprime_fichas === true,
    ficha_por: ficha === 'barraca' ? 'barraca' : 'unidade',
    operadores: numero(bruto.operadores),
    vendas_hoje: numero(bruto.vendas_hoje),
  };
}

export function ehPdv(t: TerminalCaixa): boolean {
  return (t.operating_mode ?? '').toUpperCase() === 'PDV';
}

const MIN = 60_000;
const HORA = 60 * MIN;
const DIA = 24 * HORA;

export function tempoRelativo(iso: string | null): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const diff = Date.now() - d.getTime();
  if (diff < MIN) return 'vista agora';
  if (diff < HORA) return `vista há ${Math.floor(diff / MIN)} min`;
  if (diff < DIA) return `vista há ${Math.floor(diff / HORA)} h`;
  const dias = Math.floor(diff / DIA);
  return `vista há ${dias} ${dias === 1 ? 'dia' : 'dias'}`;
}

// Linha de apoio do caixa, com a linguagem do organizador (nada de "PDV").
export function descricaoCaixa(
  caixa: CaixaDoEvento,
  apelidoPorTerminal: Map<string, string>,
): string {
  if (!caixa.terminal_externo) return 'sem maquininha · fichas de papel';
  const apelido = apelidoPorTerminal.get(caixa.terminal_externo) ?? 'Maquininha';
  if (!caixa.imprime_fichas) return apelido;
  const por = caixa.ficha_por === 'barraca' ? '1 ficha por barraca' : '1 ficha por item';
  return `${apelido} · imprime fichas · ${por}`;
}